module.exports = "/_next/static/images/fdab6827477f1d1f5fe48cc664231c3b-exemplo_rotativo.png.webp";